import { StakeWiseOsTokenAbi } from '../abis/stakewise'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * StakeWise V3 osETH reader.
 *
 * Two calls: `osETH.totalSupply()` + `OsTokenVaultController
 * .convertToAssets(1e18)`. The controller does the share→assets
 * conversion at the protocol's current exchange rate.
 *
 * Fallback: when `readerExtras.osTokenController` is absent, surface
 * a 1:1 placeholder rate.
 */
export const readerStakeWiseOsEth = (entry: LstRegistryEntry): LstReader => {
  const controller = entry.readerExtras?.osTokenController
  if (!controller) {
    return {
      calls: [{ address: entry.address, name: 'totalSupply', params: [] }],
      abis: [TotalSupplyAbi],
      parse: ([supply]) => {
        const totalSupply = toBigInt(supply)
        if (totalSupply === undefined) return undefined
        return {
          totalAssets: totalSupply,
          totalSupply,
          exchangeRate: ONE_E18,
        }
      },
    }
  }
  return {
    calls: [
      { address: entry.address, name: 'totalSupply', params: [] },
      { address: controller, name: 'convertToAssets', params: [ONE_E18] },
    ],
    abis: [TotalSupplyAbi, StakeWiseOsTokenAbi],
    parse: ([supply, rate]) => {
      const totalSupply = toBigInt(supply)
      const exchangeRate = toBigInt(rate)
      if (totalSupply === undefined || exchangeRate === undefined) {
        return undefined
      }
      return {
        totalAssets: (totalSupply * exchangeRate) / ONE_E18,
        totalSupply,
        exchangeRate,
      }
    },
  }
}
